import Cookies from 'js-cookie'
import { ACCESS_TOKEN } from '../constants/cookies'

export default function logout() {
  Cookies.remove(ACCESS_TOKEN)
}
